export default __webpack_public_path__ + "static/media/TWDB_logo_white_background.7f3121cb.JPG";